import { useEffect } from 'react';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';

const useOutOfRangeEffect = <R extends RemoteRecord<any>>(
  remoteRecord: R,
  page: number,
  onOutOfRange?: () => void,
): void => {
  useEffect(
    () => {
      if (
        remoteRecord?.data?.total && remoteRecord?.data?.pageSize
      ) {
        const pagesNumber = Math.ceil(
          remoteRecord.data.total / remoteRecord.data.pageSize,
        );

        if (page > pagesNumber || page < 1) {
          onOutOfRange?.();
        }
      }
    },
    [
      remoteRecord,
      onOutOfRange,
      page,
    ],
  );
};

export { useOutOfRangeEffect };
